module.exports = __webpack_public_path__ + "img/option_two.18b1cadb.png";